import { useRouter } from "next/router";
import React, { useContext } from "react";
import { GlobalPageDataContext } from "../../../contexts/GlobalPageDataContext";
import { ScreenContext } from "../../../contexts/ScreenContext";
import MobileViewGlobal from "../../Views/MobileView";
import MessageItem from "../MessageItem";

export default function MessageListMobileView({ messageData, me, eventSlug }) {
  const { globalPageData } = useContext(GlobalPageDataContext);
  const { inMobileView } = useContext(ScreenContext);
  const router = useRouter();
  
  const currentPageData = globalPageData[router.asPath.substring(1)];
  
  return (
    <MobileViewGlobal
      className={`message_list_mobile ${
        currentPageData?.showPublicChat &&
        inMobileView === "home" &&
        "message_list_mobile--message-live-chat-offset"
      }`}
    >
      {messageData.length > 0 &&
        messageData.map((messageItem) => {
          return (
            <MessageItem
              key={`announcement-${messageItem.id}`}
              messageItem={messageItem}
              me={me}
              eventSlug={event}
            />
          );
        })}
    </MobileViewGlobal>
  );
}
